$(function () {
    $('.delete-product').on('click', function (e) {
		const basketID=$(this).data('basketid');
        const clicked_item = {
            item_id: GA4Items[basketID].item_id,
            item_name: GA4Items[basketID].item_name,
            affiliation: GA4Items[basketID].affiliation,
            price: GA4Items[basketID].price,
            discount:GA4Items[basketID].discount,
            subscription: GA4Items[basketID].subscription,
            item_brand: GA4Items[basketID].item_brand,
            item_category: GA4Items[basketID].item_category,
			quantity: GA4Items[basketID].quantity,
            index: GA4Items[basketID].index,
            item_list_id: GA4Items[basketID].item_list_id,
            item_list_name: GA4Items[basketID].item_list_name
        }
        if (GA4Items[basketID].item_variant!==undefined){
            clicked_item['item_variant']=GA4Items[basketID].item_variant;
        }
        removeItemFromCart(clicked_item);
    })
})
const GA4Items=[];
let stopCartDLPush=false;
function removeItemFromCart(clicked_item: { item_id: string; item_name: string; affiliation: string; price: number; discount: number; item_variant?: string; subscription: string; item_brand: string; item_category: string; quantity: number; index: number;  item_list_id: string; item_list_name: string }){
    if (!stopCartDLPush){
        const deletedItem = [];
        deletedItem.push(clicked_item);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
                currency: 'CAD',
                value: Number((clicked_item.price * clicked_item.quantity).toFixed(2)),
                items: deletedItem
            }
        });
    }
    stopCartDLPush=true;
}